import React from "react";
import { NamedProperty } from "sprint-common-web";

import { VersionSummary } from "../../../../../common/types/VersionSummary";
import { PageHeader } from "../../../../../common/ui/layout/header/PageHeader";
import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { TvSeriesDetailsPageBreadcrumbs } from "../../../common/header/tv-series/TvSeriesDetailsPageBreadcrumbs";
import { CloudAssetDetailsPageHeaderActions } from "../CloudAssetDetailsPageHeaderActions";

interface TvSeriesDetailsPageHeaderProps {
    tvSeries: NamedProperty;
    season: NamedProperty;
    episode: NamedProperty;
    version: VersionSummary;
    deliveryFileName: string;
    filePath: string;
    cloudFileId: string;
    cloudAssetId: string;
    hideActions?: boolean;
}

export const CloudTvSeriesDetailsPageHeader: React.FunctionComponent<TvSeriesDetailsPageHeaderProps> = (
    props: TvSeriesDetailsPageHeaderProps
) => {
    const {
        tvSeries,
        season,
        episode,
        version,
        deliveryFileName,
        filePath,
        cloudFileId,
        cloudAssetId,
        hideActions
    } = props;

    return (
        <PageHeader>
            <TvSeriesDetailsPageBreadcrumbs tvSeries={tvSeries} season={season} episode={episode} version={version} />
            <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
                {!hideActions && (
                    <CloudAssetDetailsPageHeaderActions
                        deliveryFileName={deliveryFileName}
                        filePath={filePath}
                        cloudFileId={cloudFileId}
                        cloudAssetId={cloudAssetId}
                    />
                )}
            </AuthorizationWrapper>
        </PageHeader>
    );
};
